type Locales = {
  [key: string]: string
}

export const locale: Locales = {
  en: 'en',
  es: 'es',
  ca: 'ca',
  fr: 'fr',
  de: 'de',
  it: 'it',
  pt: 'pt',
  'pt-br': 'pt',
  'en-gb': 'en',
  'en-us': 'en',
  'es-mx': 'es',
}
